import _includes from 'lodash/includes';
import _toLower from 'lodash/toLower';
import { AllowedAppCookies, CookiesEnum, COOKIE_NAME } from './enums/GtmAppDefinition'

/**
 * Fire Google event
 * @param {object} data dataLayer object , { event: 'myEvent', ...someAttributes }
 */
export function gtm(data) {
  if (process.client) {
    window.dataLayer.push({ ecommerce: null }) // Clear the previous ecommerce object.
    window.dataLayer.push(data)
  }

}

/* Fire Google event ON  App detecttion according GtmAppDefinitionto  */
/**
 * @see alertCookieValue
 * @see AllowedAppCookies
 * @param {String} drushim_platform cookie
 *
 */

export function inAppGtm() {
  let platform = alertCookieValue('drushim_platform')
  if (AllowedAppCookies.includes(platform)) {
    let dataLayer = {
      deviceTest: 'app',
      event: 'platform_type'
    }

    window.dataLayer.push(dataLayer)
  } else {
    let dataLayer = {
      deviceTest: 'web',
      event: 'platform_type'
    }

    window.dataLayer.push(dataLayer)
  }
  addPlatformClass(platform)
}

function addPlatformClass(platform) {
  if (platform.length > 0 && process.browser)
    window.document.body.classList.add(platform)
}
/** Get cookie value by name 
 * @param {String} cookieName cookie 
   @return {String} cookieValue 
 */

function alertCookieValue(cookieName) {
  if (cookieExists(cookieName)) {
    const cookieValue = document.cookie
      .split('; ')
      .find(row => row.startsWith(cookieName))
      .split('=')[1]

    return cookieValue
  }
  return ''
}

/** 
 * @param {String} cookieName checj cookieExists  
   @return {Boolean}  
 */

function cookieExists(cookieName) {
  return document.cookie
    .split(';')
    .some(item => item.trim().startsWith(cookieName))
}

// SERVER CODE
const USERAGENT_VAL = 'DrushimApp';
const HEADER_KEY = 'x-requested-with';
const HEADER_VAL = 'drushim.app';

/**
 * @param {object} req request object 
 * @returns {boolean} true if user agent string contains mobile value
 */
export function hasMobileUserAgent(req) {
  const userAgent = _toLower(req.headers['user-agent']);
  return userAgent.includes(_toLower(USERAGENT_VAL));
}

/**
 * @param {object} req request object 
 * @returns {boolean} true if header string contains mobile value
 */
export function hasMobileHeader(req) {
  const header = _toLower(req.headers[HEADER_KEY]);
  return header === _toLower(HEADER_VAL);
}

/**
 * This class instance is responsible for checking platform cookie
 * It is meant for use as nuxt middleware
 * 1. check if platform cookie already exists. If yes - do not proceed.
 * 2. set cookie with correct value.
 * @see CookiesEnum
 * @see COOKIE_NAME
 */
class GtmHandler {

  /**
   * @see cookie-universal-nuxt
   * @param {object} req request
   * @param {object} cookies server cookie utility 
   */
  constructor({ req, app }) {
    this.req = req;
    this.cookies = app ? app.$cookies : req.cookies;
  }

  /**
   * Main entry point for class operation
   */
  run() {
    if (this.hasCookie) return; // cookie already exists. exit code

    this.setCookie(this.platform);
  }

  /**
   * @returns {string|undefined} platform cookie
   */
  getCookie() {
    return this.req.cookies[COOKIE_NAME];
  }

  /**
   * 
   * @param {string} value platform cookie value
   */
  setCookie(value) {
    this.cookies.set(COOKIE_NAME, value);
  }

  /**
   * @returns {boolean} true if request has platform cookie
   */
  get hasCookie() {
    const cookie = this.getCookie();
    return _includes(CookiesEnum, cookie);
  }

  /**
   * @returns {boolean} true if IOS, false otherwise
   */
  get ios() {
    return hasMobileUserAgent(this.req);
  }

  /**
   * @returns {boolean} true if android OS, false otherwise
   */
  get android() {
    return hasMobileHeader(this.req);
  }

  /**
   * @returns {string} platform cookie value
   */
  get platform() {
    const { ios, android, web } = CookiesEnum;
    let result;

    if (this.ios)
      result = ios;
    else if (this.android)
      result = android;
    else
      result = web;

    return result;
  }
}

/**
 * Use as server middleware. does not use nuxt-universal-cookie
 * It uses res.cookie to set cookie
 */
export class ServerGtmHandler extends GtmHandler {
  constructor(context) {
    super(context);
    this.res = context.res;
  }

  /**
   * set platform cookie value
   * @param {string} value platform cookie value 
   */
  setCookie(value) {
    this.res.cookie(COOKIE_NAME, value);
  }
}

/**
 * Runs GTM server logic
 * 
 * @param {object} context nuxt context
 * @param {object} context.req request object
 * @param {object} context.app nuxt app instance. Should have app.$cookies
 */
export function AppGtmMiddleware(context) {
  const gtm = new GtmHandler(context);
  gtm.run();
}

export default gtm
